import React from 'react';

import { blogCmsClient } from 'src/lib/contentful-client';
import { ContentfulTemplates, isTesting } from 'src/lib/constants';
import { TemplateSwitch } from 'src/templates';
import { fetchAllEntries, fetchEntryId } from 'src/lib/utils';
import { optimizeContentfulImages } from 'src/lib/image-helpers';

// TemplateSwitch routes to BlogPostTemplate and provides the Contentful
// live preview context (inspector mode + live updates) like other routes
const BlogPost = (props) => {
  return <TemplateSwitch {...props} />;
};

// Static build: uses getStaticPaths to pre-generate all blog post pages at build time
export async function getStaticPaths() {
  let entries;
  try {
    entries = await fetchAllEntries({
      contentType: ContentfulTemplates.BLOG_POST,
    });
  } catch (e) {
    throw new Error(e);
  }

  const paths = entries.reduce((pagePaths, entry) => {
    if (entry.fields.pageSlug) {
      pagePaths.push({
        params: {
          post: entry.fields.pageSlug,
        },
      });
    }
    return pagePaths;
  }, []);

  return {
    paths: isTesting ? [] : paths,
    fallback: false,
  };
}

export async function getStaticProps({ params, preview }) {
  const { post } = params;
  let postId;
  try {
    postId = await fetchEntryId({
      contentType: ContentfulTemplates.BLOG_POST,
      param: 'fields.pageSlug',
      query: post,
    });
  } catch (e) {
    throw new Error(e);
  }
  let entry;
  try {
    entry = await blogCmsClient.getEntries({
      'sys.id': postId,
      include: 10,
    });
  } catch (e) {
    throw new Error(e);
  }

  const data = { ...entry?.items[0], preview: !!preview };
  return { props: optimizeContentfulImages(data) };
}

export default BlogPost;
